import type { Dayjs } from 'dayjs';
import type { TaxBandRule } from 'app/pages/TaxManager/taxTypes';
import { taxBandRuleToApiBand } from './taxBandMappers';

function dayjsToIsoDateString(d: Dayjs | null | undefined): string | null {
  if (!d || !d.isValid()) return null;
  return d.format('YYYY-MM-DD');
}

function countryIsoCodeForPayload(v: number | string): string | null {
  if (v === '' || v == null) return null;
  if (typeof v === 'number') {
    return Number.isFinite(v) && v > 0 ? String(v) : null;
  }
  const s = String(v).trim();
  return s === '' || s === '0' ? null : s;
}

export function buildTaxRulePutPayload(params: {
  name: string;
  applyToSpecificCentre: boolean;
  countryId: number | string;
  centreId: number;
  startDate: Dayjs;
  endDate: Dayjs | null;
  isActive: boolean;
  bands: TaxBandRule[];
}): Record<string, unknown> {
  const startIso = dayjsToIsoDateString(params.startDate);
  if (!startIso) {
    throw new Error('Invalid start date');
  }
  const countryIsoCode = params.applyToSpecificCentre
    ? null
    : countryIsoCodeForPayload(params.countryId);
  const centreId =
    params.applyToSpecificCentre && params.centreId > 0 ? params.centreId : null;
  return {
    name: params.name.trim(),
    countryIsoCode,
    centreId,
    startDate: startIso,
    endDate: params.endDate ? dayjsToIsoDateString(params.endDate) : null,
    isActive: params.isActive,
    bands: params.bands.map(taxBandRuleToApiBand),
  };
}